import { DeleteIcon, IconButton, Skeleton, styled, TableCell, TableRow } from 'opensolar-ui'
import { useTranslate } from 'ra-core'

/** Select Source column: selector width + same horizontal padding as other cells (12px each side) */
export const SELECT_SOURCE_SELECTOR_WIDTH = 200
const TABLE_CELL_PADDING_X = 12
export const SELECT_SOURCE_COLUMN_WIDTH = SELECT_SOURCE_SELECTOR_WIDTH + TABLE_CELL_PADDING_X * 2

const StyledTableCell = styled(TableCell)<{
  minWidth: number
  borderTopLeftRadius?: string
  borderTopRightRadius?: string
}>(({ minWidth, borderTopLeftRadius, borderTopRightRadius }) => ({
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '18px',
  minWidth,
  padding: '10px 12px',
  borderTopLeftRadius,
  borderTopRightRadius,
  width: 'auto',
}))

const PriceHeader = styled('span')({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'end',
})

const ClearCartHeaderButton = styled(IconButton)(({ theme }) => ({
  padding: 4,
  color: theme.palette.grey[600],
  '&:hover': {
    color: theme.palette.grey[900],
    backgroundColor: theme.palette.grey[200],
  },
}))

type CartTableHeadersProps = {
  isLoading?: boolean
  isProjectView?: boolean
  onClearCartClick?: () => void
}

export const CartTableHeaders = ({ isLoading = false, isProjectView, onClearCartClick }: CartTableHeadersProps) => {
  const translate = useTranslate()
  return (
    <TableRow>
      <StyledTableCell borderTopLeftRadius="8px" minWidth={350}>
        {isLoading ? <Skeleton width={200} height={20} /> : translate('Product Name')}
      </StyledTableCell>
      <StyledTableCell minWidth={60}>
        {isLoading ? <Skeleton width={50} height={20} /> : translate('Category')}
      </StyledTableCell>
      <StyledTableCell minWidth={60}>
        {isLoading ? <Skeleton width={40} height={20} /> : translate('Qty')}
      </StyledTableCell>
      <StyledTableCell minWidth={158}>
        {isLoading ? <Skeleton width={100} height={20} /> : translate('Select Source')}
      </StyledTableCell>
      <StyledTableCell minWidth={120}>
        {isLoading ? <Skeleton width={80} height={20} /> : translate('Stock Status')}
      </StyledTableCell>
      <StyledTableCell borderTopRightRadius={isProjectView ? '8px' : ''} minWidth={90}>
        {isLoading ? (
          <Skeleton width={80} height={20} />
        ) : (
          <PriceHeader>
            <span>{translate('Price')}</span>
            <span style={{ fontSize: '12px', fontWeight: 400 }}>({translate('Unit Price')})</span>
          </PriceHeader>
        )}
      </StyledTableCell>
      {/* Temporarily hidden: Project Allocation column
      {!isProjectView && (
        <StyledTableCell minWidth={160}>
          {isLoading ? <Skeleton width={100} height={20} /> : translate('Project Allocation')}
        </StyledTableCell>
      )}
      */}
      {!isProjectView && (
        <StyledTableCell minWidth={25} borderTopRightRadius="8px" style={{ verticalAlign: 'middle' }}>
          {isLoading ? (
            <Skeleton width={100} height={20} />
          ) : onClearCartClick ? (
            <ClearCartHeaderButton
              size="small"
              onClick={onClearCartClick}
              aria-label={translate('Clear cart')}
              title={translate('Clear cart')}
            >
              <DeleteIcon width="20" height="20" />
            </ClearCartHeaderButton>
          ) : (
            ''
          )}
        </StyledTableCell>
      )}
    </TableRow>
  )
}
